import {
  BOOKING_REQUEST_START,
  BOOKING_REQUEST_SUCCESS,
  BOOKING_REQUEST_ERROR,
} from '../../constants';
import showToaster from '../../helpers/showToaster';
import { createReservation as mutation } from '../../lib/graphql';

export function submitBookingRequest(
  listId,
  title,
  hostId,
  guestId,
  checkIn,
  checkOut,
  guests,
  message,
  basePrice,
  cleaningPrice,
  taxPrice,
  currency,
  discount,
  discountType,
  guestServiceFee,
  hostServiceFee,
  total,
  bookingType,
  specialPricing,
  isSpecialPriceAssigned,
  isSpecialPriceAverage,
  dayDifference,
  taxRate,
  checkInStart,
  checkInEnd,
  hostServiceFeeType,
  hostServiceFeeValue,
  threadId,
  guestServiceFeeType,
  guestServiceFeeValue,
  extraGuestFeeAmount,
  extraGuestCount,
  extraGuestFee,
  cautionDeposit,
) {

  return async (dispatch, getState, { client }) => {

    dispatch({
      type: BOOKING_REQUEST_START,
      payload: {
        paymentLoading: true
      }
    });

    try {
      let cancellationPolicy = getState().book.data.listingData.cancellation.id;

      const { data } = await client.mutate({
        mutation,
        variables: {
          listId: Number(listId),
          hostId,
          guestId,
          checkIn,
          checkOut,
          guests,
          message,
          basePrice,
          cleaningPrice,
          taxPrice,
          currency,
          discount,
          discountType,
          guestServiceFee,
          hostServiceFee,
          total,
          bookingType: 'request', // Always set as request, not instant
          paymentType: null, // No payment type yet
          cancellationPolicy,
          specialPricing,
          isSpecialPriceAssigned,
          isSpecialPriceAverage: parseFloat(isSpecialPriceAverage),
          dayDifference,
          taxRate,
          checkInStart,
          checkInEnd,
          hostServiceFeeType,
          hostServiceFeeValue,
          threadId,
          guestServiceFeeType,
          guestServiceFeeValue,
          extraGuestFeeAmount,
          extraGuestCount,
          extraGuestFee,
          cautionDeposit,
        }
      })

      if (data?.createReservation) {
        let reservationId = data?.createReservation.id;
        
        dispatch({
          type: BOOKING_REQUEST_SUCCESS,
          payload: { 
            paymentLoading: false,
            reservationId
          }
        });

        showToaster({ 
          messageId: 'bookingRequestSent', 
          toasterType: 'success' 
        });

        return {
          status: 200,
          reservationId
        }
      }
    } catch (error) {
      dispatch({
        type: BOOKING_REQUEST_ERROR,
        payload: {
          error,
          paymentLoading: false
        }
      });
      
      showToaster({ 
        messageId: 'commonError', 
        toasterType: 'error' 
      });
      
      return false;
    }

    return true;
  };
}